import { render, staticRenderFns } from "./akutansi.vue?vue&type=template&id=ba87bb9e&scoped=true&"
import script from "./akutansi.vue?vue&type=script&lang=js&"
export * from "./akutansi.vue?vue&type=script&lang=js&"
import style0 from "./akutansi.vue?vue&type=style&index=0&id=ba87bb9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba87bb9e",
  null
  
)

export default component.exports